module.exports = __webpack_public_path__ + "img/barrier-fence.e375db1.jpg";